import Tabs from "./tabs";
import MiniMasonry from "minimasonry";
import certificatesLoadMore from "./certificatesLoadMore";
import StickyBlock from "./stickyBlock";
import scrollTop from "../utils/scrollTop";

const stickyCertificateArchive = new StickyBlock('.js-sticky-certificate-archive', '.js-sticky-certificate-archive-wrapper', 1250);

const certificatesMasonry = (masonryClass = '.js-certificates-masonry', parent = '.js-certificates-tab') => {
    let masonry = [];

    $(masonryClass).each((i, el) => {
        if ($(window).width() > 576) {
            masonry[i] = new MiniMasonry({
                container: el,
                surroundingGutter: false,
                gutterX: 30,
                gutterY: 30,
                minify: false
            });
        }

        setTimeout(() => {
            let currentParent = $(el).parents(parent);
            $(currentParent).removeClass('loading');
        }, 100);
    });

    $(window).on('resize', (ev) => {
        if ($(window).width() < 576) {
            masonry.forEach((item) => {
                item.destroy()
            })
        } else {
            masonry.forEach((item) => {
                item.layout()
            })
        }
    });

    const updateMasonry = () => {
        masonry.forEach((item) => {
            item.layout()
        })
    };

    const update = () => {
        stickyCertificateArchive.destroy();
        stickyCertificateArchive.init();
        updateMasonry();
        scrollTop();
    }

    const certificateTabs = new Tabs('.js-certificate-tab-link', update);
    certificateTabs.init();
    stickyCertificateArchive.init();

    certificatesLoadMore('.js-certificates-masonry', '.js-certificates-download', '.js-certificates-tab', updateMasonry);
}
export default certificatesMasonry;